import { FC } from "react";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Typography,
} from "@mui/material";

interface CalendarDisplayTypeCardProps {
  label: string;
  description: string;
  imgSrc: string;
  isSelected?: boolean;
  isDisabled?: boolean;
  onClick?: () => void;
}

export const CalendarDisplayTypeCard: FC<CalendarDisplayTypeCardProps> = ({
  label,
  description,
  imgSrc,
  isSelected = false,
  isDisabled = false,
  onClick,
}) => (
  <Card
    elevation={0}
    sx={{
      borderRadius: 2,
      border: "1px solid",
      borderColor: isSelected ? "primary.main" : "grey.300",
      backgroundColor: isSelected ? "primary.light" : "grey.light",
      transition: "all 0.2s ease",
      ...(!isDisabled && {
        "&:hover": {
          borderColor: "primary.main",
          backgroundColor: "primary.light",
        },
      }),
    }}
  >
    <CardActionArea
      disableRipple={isDisabled}
      disableTouchRipple={isDisabled}
      onClick={isDisabled ? undefined : onClick}
      sx={{
        p: 0,
        m: 0,
        height: "100%",
        alignItems: "stretch",
        ...(isDisabled && {
          cursor: "default",
          "& .MuiCardActionArea-focusHighlight": {
            opacity: 0,
          },
          "&:hover .MuiCardActionArea-focusHighlight": {
            opacity: 0,
          },
        }),
      }}
    >
      <CardContent sx={{ p: 2 }}>
        <Typography
          sx={(theme) => ({
            fontSize: theme.fontSize.medium,
            fontWeight: theme.fontWeight.semiBold,
          })}
          gutterBottom
        >
          {label}
        </Typography>

        <Box
          sx={{
            borderRadius: 1,
            overflow: "hidden",
            mb: 2,
            backgroundColor: "grey.100",
          }}
        >
          <Box
            component="img"
            src={imgSrc}
            alt={label}
            sx={{
              width: "100%",
              objectFit: "contain",
              display: "block",
            }}
          />
        </Box>

        <Typography
          sx={(theme) => ({
            fontSize: theme.fontSize.small,
            color: theme.palette.grey.medium,
          })}
        >
          {description}
        </Typography>
      </CardContent>
    </CardActionArea>
  </Card>
);
